module.exports = __webpack_public_path__ + "static/media/colheitadeira.8d38febb.svg";